<template>
  <v-row justify="center">
    <v-dialog :value="value" width="800px" @input="$emit('input')">
      <v-card>
        <v-card-title>
          <span class="headline"
            ><strong>{{ title }}</strong></span
          >
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4" v-for="(post, index) of posts" :key="index">
              <Post :post="post" @selected="$emit('onSelect', post)" :isSelected="selectedPostIds.has(post.shortcode)" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" align="center" justify="center">
              <v-btn class="ma-2" small tile outlined color="secondary" @click="$emit('prev_page')"> <v-icon small left>mdi-chevron-left</v-icon> Back </v-btn>
              <v-btn class="ma-2" small tile outlined color="secondary" @click="$emit('next_page')"> Next<v-icon small right>mdi-chevron-right</v-icon> </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="close">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Post from './Post';
export default {
  props: {
    value: Boolean,
    posts: Array,
    title: String,
    selectedPostIds: Object
  },
  components: {
    Post
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    close() {
      this.$emit('input');
    }
  }
};
</script>



// WEBPACK FOOTER //
// PostView.vue?e35db862